import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../trigger-field/style';
import '../../pagination/style';
import '../../tabs/style';
